import axios from 'axios'

const instance = axios.create({
  // baseURL: 'https://tajimi-test.president-one-dev.com/admin/api/v1'
  baseURL: process.env.VUE_APP_BASE_URL_API
})
export default instance
